<template>
  <div class="flex py-10 flex-col px-7">
    <div class="titles py-10 flex items-center justify-between">
      <div class="">
        <div class="title text-lg font-semibold" style="margin-bottom: 2rem">Brief</div>
        <div class="subtitle" style="margin-bottom: 10px">
          Here is the <b class="">{{ project.name }} </b> brief shared with you
        </div>
      </div>
      <div class="flex brief-actions">
        <ts-button size="small" @click="handleEditClick"> Edit brief </ts-button>
        <ts-button
          size="small"
          type="primary"
          :loading="loading"
          :disabled="loading"
          filled
          @click="handleSubmitBriefClick"
        >
          Submit your brief
        </ts-button>
      </div>
    </div>
    <div class="mx-auto max-w-5xl w-full list" style="margin-top: 1.2rem">
      <div v-if="this.brief && this.brief.specific && this.brief.specific.length != 0">
        <ts-form-section :title="item.title" class="form-section column" v-for="item in this.brief.specific" :key="item.id">
          <ts-form-item :label="item.label" class="form-item">
            <p v-if="item.value != ''">{{ item.value }}</p>
            <p v-if="item.value == ''">N/A</p>
          </ts-form-item>
        </ts-form-section>
      </div>
    </div>
  </div>
</template>

<script>
import { updateSharedProjectBrief } from '@/api/workflow';
import FinalAssetList from '@/views/workflow//delivery/FinalAssetList';
import PlatformList from '@/components/PlatformList.vue';

import projectViewHelpers from '@/mixins/projectViewHelpers';
import BriefItem from './BriefItem.vue';
import {mapActions} from "vuex";
export default {
  name: 'DeliverySharedResource',
  mixins: [projectViewHelpers],
  components: {
    PlatformList,
    FinalAssetList,
    BriefItem
  },
  props: {
    resource: {
      type: Object,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      formData: [],
      brief: {},
      briefSelected: 'b1',
      form: {
        topic: {
          description: '',
          supportingFiles: []
        },
        objectives: {
          primaryObjective: {
            type: ''
          },
          secondaryObjective: {
            type: ''
          },
          supportingFiles: []
        },
        audiences: [],
        scope: {
          deliverables: '',
          languagesNeeded: '',
          supportingFiles: []
        },
        additionalSections: [],
        supportingFiles: [],
        specific:[]
      }
    }
  },
  computed: {
    isViewable() {
      return this.resource && this.hasContent();
    }
  },
  async mounted() {
    if (!this.isViewable) {
      sessionStorage.setItem('brief.filled', true);
      this.$router.push({ name: 'projects.sharings.edit-brief', params: { token: this.token } });
      return;
    }
    // await this.fetchProjectResource({ token: this.$route.params.token });
    this.brief = await this.fetchCurrentProjectBriefId(this.project.id);

    if (this.brief) {
      if (this.brief.template) {
        this[this.brief.template] = this.brief.specific;
        for (const value of this.brief.specific) {
          this.formData[value.id] = value.value;
        }
        this.briefSelected = this.brief.template;
      }
    }
    // if (sessionStorage.getItem('brief.filled') == null) {
    //   let message = `You have been invited by your Producer to complete your <em>${this.project.name}</em> project Brief. <br /> Review the information and press edit to modify your brief if needed`;
    //   window.EventBus.$emit('download.pending', message);
    //   sessionStorage.setItem('brief.filled', true);
    // }
  },
  methods: {
    ...mapActions('workflow', ['fetchProjectResource']),
    ...mapActions('workflow/brief', ['fetchCurrentProjectBriefId']),
    hasContent() {
      return this.resource.validated || !this.isEmpty(this.resource, ['updatedAt', 'updatedBy', 'id']);
    },
    isEmpty(data, except = []) {
      if (!data) {
        return true;
      }

      if (typeof data === 'string') {
        return data.length == 0;
      }

      if (Array.isArray(data)) {
        return data.length == 0;
      }

      if (typeof data === 'object') {
        for (let key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key) && !except.includes(key)) {
            let value = data[key];
            if (!this.isEmpty(value)) return false;
          }
        }
      }

      return true;
    },
    handleSubmitBriefClick() {
      updateSharedProjectBrief({
        projectId: this.currentProjectId,
        token: this.token,
        brief: {
          shouldSubmit: true
        }
      })
        .then(brief => {
          this.loading = false;
          window.EventBus.$emit('download.pending', 'Your brief has been submitted to your producer !');
        })
        .catch(err => {
          console.error('Server error when updating project brief', err);
          this.showError('Error when updating project brief');
          this.loading = false;
        });
    },
    handleEditClick() {
      this.$router.push({ name: 'projects.sharings.edit-brief', params: { token: this.token } });
    }
  }
};
</script>

<style scoped lang="scss">
.brief-actions {
  & > * {
    margin-left: 30px;
  }
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.column {
  margin-top: 25px;
  flex-direction: column;
}

</style>
